import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const managingSchoolsRouter: RouteConfig = {
  path: "/managing-sys",
  name: "managing-sys",
  component: Layout,
  meta: {
    title: "运维数据大屏",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
     {
      path: "operationsData",
      name: "operationsData",
      component: () =>
        import(
          /* webpackChunkName: "update-role" */ "@/views/managingSchools/dataIndex.vue"
        ),
      meta: {
        title: "运维各学校数据",
        hidden: false,
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "data-dashboard",
      name: "data-dashboard",
      component: () =>
        import(
          /* webpackChunkName: "user" */ "@/views/managingSchools/index.vue"
        ),
      meta: {
        title: "运维人员管理",
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "screen",
      name: "screen",
      component: () =>
        import(
          /* webpackChunkName: "update-role" */ "@/views/managingSchools/screenTv/index.vue"
        ),
      meta: {
        title: "运维数据大屏pc版",
        hidden: false,
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "screenTv",
      name: "screenTv",
      component: () =>
        import(
          /* webpackChunkName: "update-role" */ "@/views/managingSchools/screenTv/tvInddex.vue"
        ),
      meta: {
        title: "运维数据大屏TV版",
        hidden: false,
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "updateAdministrator/:id/:phone",
      name: "updateAdministrator",
      component: () =>
        import(
          /* webpackChunkName: "update-role" */ "@/views/managingSchools/createAndUpdate/index.vue"
        ),
      meta: {
        title: "创建修改",
        hidden: true,
        permission: "Pages.Settings.Role.Update"
      }
    },
  ]
};

export default managingSchoolsRouter;
